<ng-container *ngIf="viewModel$ | async as vm">

  <section  class="is-flex items-align-center">
    <app-icon  
      name="chevron-left" 
      class="chevron text-24 text-grey-50 bg-grey-10 bg-grey-hover-30 is-align-start" 
      [class.disabled]="!hasPreviousDevice(vm.reportDevices, vm.currentDevice)"
      (click)="selectPreviousThermostat(vm.reportDevices, vm.currentDevice)">
    </app-icon>
    <app-text class="is-family-semiBold text-16 text-grey-70 device-name"> {{ vm.currentDevice?.name}}</app-text>
    <app-icon 
      name="chevron-right"
      class="chevron text-24 text-grey-50 bg-grey-10 bg-grey-hover-30 is-align-end"
      [class.disabled]="!hasNextDevice(vm.reportDevices, vm.currentDevice)"
      (click)="selectNextThermostat(vm.reportDevices, vm.currentDevice)"
      >
    </app-icon>
  </section>    
</ng-container>
